<div class="btn-group" dropdown>
  <div id="button-basic" dropdownToggle aria-controls="dropdown-basic" class="mouse-pointer">
    <i class="fas fa-user-alt fa-xs" [className]="headerstyles.headertextcolorclassname"></i><span class="caret"></span>
    <span class="ms-2" [className]="headerstyles.headertextcolorclassname">{{fullname}}</span>
  </div>
  <ul id="dropdown-basic" *dropdownMenu class="dropdown-menu"
      role="menu" aria-labelledby="button-basic">
    <ng-container *ngIf="displayEdit">
      <li role="menuitem"><a class="dropdown-item" [routerLink]="['/profil']"><i
        class="fas fa-user-edit"></i> {{i18n.get('global_profil_label')}}</a></li>
    </ng-container>
    <li role="menuitem"><a class="dropdown-item"
                           (click)="onLogout()">
      <i class="fas fa-sign-out-alt"></i> {{i18n.get('global_logout_label')}}</a></li>
  </ul>
</div>

